import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
import { Mgt2Service } from 'src/app/services/mgt2.service';
declare var $: any;
@Component({
  selector: 'app-mgt2list',
  templateUrl: './mgt2list.component.html',
  styleUrls: ['./mgt2list.component.css']
})
export class Mgt2listComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerMgt2List: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  response: boolean;
  debentureHolderName:any;
  searchResponse:boolean;
  deleteMgt2Id:any;
  editParticularId: any;
  doDebenture: any;
  doCessation: any;
  doCessationTo: any;
 
  constructor(private Mgt2Service: Mgt2Service,
              private router: Router,
              private alert: AlertComponent,private route: ActivatedRoute
              ) {
    this.response = false;
  }
 
  ngOnInit() {
 
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MGT-2 List',
          title: 'MGT-2 List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
 
        }
      ]
    };
    this.getRegisterMgt2List();
  }
 
 
  // loadDetailsById(directorId) {
  //   this.router.navigate(['/intern/edit/', directorId]);
  // }
 
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#mgt2listTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      console.log("masterDirectorList", this.masterDirectorList)
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#mgt2listTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }
 
  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#mgt2listTable").DataTable().columns.adjust().draw();
    });
  }
 
 
  getRegisterMgt2List() {
    this.registerMgt2List = [];
    this.Mgt2Service.getRegisterMgt2().subscribe(registerList => {
      console.log("registerList", registerList);
      this.registerMgt2List = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }

  confirmDelete(id) {
    this.deleteMgt2Id = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletemgt2tdetail(){

    this.Mgt2Service.removemgt2details(this.deleteMgt2Id)
    .subscribe(response => {
      if (response.status == 0) {
        // $("#mgt2listTable").DataTable().destroy();
        this.alert.success(response.message);
        $("#mgt2listTable").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
        this.getRegisterMgt2List();
        // this.alert.success(response.message);
      } else {
        this.alert.error(response.message);
      }
     
    });
 }

 editmgt2detail(_id) {
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['mgt2', 'edit',_id]  } }],
    { relativeTo: this.route.parent });
  // this.router.navigate(['mgt2/edit/', _id]);
}

generateOutput() {
  let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
  var object = {
    id: null,
    fromDate: this.doCessation,
    toDate: this.doCessationTo,
    name: this.debentureHolderName
  }
  this.Mgt2Service.generateMgt2Document(object).subscribe(response => {
    if (response.status == 0) {
      this.alert.success(response.message);
      var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
    } else {
      this.alert.error(response.message);
    }
  })
}

downloadDocument(id) {
  this.Mgt2Service.downloadMgt2File(id, 'Multi');
}
downloadPdfDocument(id) {
  this.Mgt2Service.downloadMgt2PdfFile(id, 'Multi');
}

setDate(date) {
  if (date != "" && date != null) {
    return date.month + "-" + date.day + "-" + date.year;
  }
  return null;
}
doAdvSearch() {
  this.searchResponse = true;
  var searchParam =
  {
    "doDebenture": this.setDate(this.doDebenture),
    "doCessation": this.setDate(this.doCessation),
    "doCessationTo": this.setDate(this.doCessationTo),
    "debentureHolderName": this.debentureHolderName,
    'isSearch': true,
  };
  this.registerMgt2List = [];
  $("#mgt2listTable").DataTable().destroy();
  this.Mgt2Service.getMgt2SearchList(searchParam).subscribe(registerList => {
    console.log(registerList);
    this.searchResponse = false;
    this.registerMgt2List = registerList.data;
    this.dtTriggerRegisterDirector.next();
  });
}
addMGT2(){
  this.router.navigate(
    [{ outlets: { 'structure-outlet': ['mgt2', 'add']  } }],
    { relativeTo: this.route.parent });
}
 
toggleSearchDiv() {
  this.isSearchDivVisible = !this.isSearchDivVisible;
}

clearAdvSearch() {
  this.debentureHolderName = '';
  this.doDebenture = '';
  this.doCessation = undefined;
  this.doCessationTo = undefined;
  $("#mgt2listTable").DataTable().destroy();
  this.getRegisterMgt2List();
  this.searchResponse = false;
}

}
